import "maplibre-gl/dist/maplibre-gl.css";
import { useParams } from "wouter";
// import { ArtBoxCard } from "../components/ArtBox";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../db";
import { Carousel } from "../components/Carousel";
import { SocialLink } from "../components/SocialLink";
import styles from "./Artwork.module.css";

export function Artwork() {
  const { id } = useParams<{ id: string }>();

  const box = useLiveQuery(() => db.boxes.get(id), [id]);

  const images = useLiveQuery(
    () => db.boxImages.where({ artist: id }).toArray(),
    [id]
  );

  const srcs = images?.map((im) => im.src) || [];

  return (
    <>
      {box && (
        <>
          <section className={styles.carouselContainer}>
            <Carousel images={srcs} />
          </section>

          <header className={styles.header}>
            <h1>{box.title}</h1>
            <h2>{box.artist}</h2>
            <p>{box.year}</p>
          </header>

          <main>
            <p>{box.description}</p>

            <hr />
            <h3>About the artist</h3>
            <p>{box.biography}</p>

            <nav className={styles.links}>
              {box.links
                .split(" ")
                .map(decodeURI)
                .map((href) => (
                  <SocialLink href={href} key={href} />
                ))}
            </nav>
          </main>
        </>
      )}
    </>
  );
}
